import { addIcons } from "ionicons";
import {
  addOutline,
  addSharp,
  albumsOutline,
  alertCircle,
  alertCircleOutline,
  arrowBackOutline,
  arrowForward,
  arrowForwardCircle,
  arrowForwardCircleOutline,
  arrowForwardOutline,
  arrowUp,
  bookOutline,
  briefcaseOutline,
  buildOutline,
  calendarOutline,
  callOutline,
  cardOutline,
  caretDownOutline,
  chatboxOutline,
  chatbubblesOutline,
  checkmark,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkOutline,
  chevronBack,
  chevronBackOutline,
  chevronDownCircleOutline,
  chevronDownOutline,
  chevronForwardOutline,
  clipboardOutline,
  close,
  closeCircleOutline,
  closeOutline,
  cloudUpload,
  cogOutline,
  copyOutline,
  diamondOutline,
  documentTextOutline,
  ellipsisVertical,
  eyeOffOutline,
  eyeOutline,
  flash,
  flashOutline,
  folderOpenOutline,
  funnelOutline,
  giftOutline,
  globeOutline,
  helpCircle,
  helpOutline,
  homeOutline,
  hourglassOutline,
  informationCircle,
  informationCircleOutline,
  informationCircleSharp,
  keypad,
  language,
  link,
  linkOutline,
  locationOutline,
  lockClosed,
  logOutOutline,
  logoFacebook,
  menu,
  notificationsOutline,
  openOutline,
  pencilOutline,
  peopleCircleOutline,
  peopleOutline,
  person,
  personCircleOutline,
  personOutline,
  phonePortraitOutline,
  playCircleOutline,
  receiptOutline,
  refresh,
  refreshOutline,
  removeCircleOutline,
  removeSharp,
  schoolOutline,
  search,
  settingsOutline,
  shield,
  star,
  starHalf,
  starOutline,
  swapHorizontalOutline,
  syncOutline,
  timeOutline,
  trashOutline,
  warning,
  warningOutline,
} from "ionicons/icons";

/**
 * Registers every built-in icon referenced by application templates.
 * Standalone Ionic components require explicit icon data and must not rely on
 * runtime /svg/ requests, which are unavailable in the packaged application.
 */
export function registerAppIcons(): void {
  addIcons({
    addOutline,
    addSharp,
    albumsOutline,
    alertCircle,
    alertCircleOutline,
    arrowBackOutline,
    arrowForward,
    arrowForwardCircle,
    arrowForwardCircleOutline,
    arrowForwardOutline,
    arrowUp,
    bookOutline,
    briefcaseOutline,
    buildOutline,
    calendarOutline,
    callOutline,
    cardOutline,
    caretDownOutline,
    chatboxOutline,
    chatbubblesOutline,
    checkmark,
    checkmarkCircle,
    checkmarkCircleOutline,
    checkmarkOutline,
    chevronBack,
    chevronBackOutline,
    chevronDownCircleOutline,
    chevronDownOutline,
    chevronForwardOutline,
    clipboardOutline,
    close,
    closeCircleOutline,
    closeOutline,
    cloudUpload,
    cogOutline,
    copyOutline,
    diamondOutline,
    documentTextOutline,
    ellipsisVertical,
    eyeOffOutline,
    eyeOutline,
    flash,
    flashOutline,
    folderOpenOutline,
    funnelOutline,
    giftOutline,
    globeOutline,
    helpCircle,
    helpOutline,
    homeOutline,
    hourglassOutline,
    informationCircle,
    informationCircleOutline,
    informationCircleSharp,
    keypad,
    language,
    link,
    linkOutline,
    locationOutline,
    lockClosed,
    logOutOutline,
    logoFacebook,
    menu,
    notificationsOutline,
    openOutline,
    pencilOutline,
    peopleCircleOutline,
    peopleOutline,
    person,
    personCircleOutline,
    personOutline,
    phonePortraitOutline,
    playCircleOutline,
    receiptOutline,
    refresh,
    refreshOutline,
    removeCircleOutline,
    removeSharp,
    schoolOutline,
    search,
    settingsOutline,
    shield,
    star,
    starHalf,
    starOutline,
    swapHorizontalOutline,
    syncOutline,
    timeOutline,
    trashOutline,
    warning,
    warningOutline,
  });
}
